
export const ValidateAccountAdminFuncInput = (account, _createErrorMessage) => {

  if (!account) {
    _createErrorMessage("59");
    return false;
  }

  return true;
};
